import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { tickTypewriter } from "../engine/drivers.js";

/**
 * TypewriterNode
 * --------------
 * Reveals text character-by-character at a controllable speed.
 * Outputs the partial string. Wire to TextRender for animated text reveals.
 */
export class TypewriterNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Typewriter";

    this.properties = {
      speed: 4,
      loop: true,
      pauseAtEnd: 30,
    };

    this._charIndex = 0;
    this._pauseCounter = 0;
    this._lastText = "";

    this.addInput("Text", "string");
    this.addOutput("Text", "string");

    addDrivableSlider(this, "Speed", "speed", 4, 0.5, 30, 0.5);
    addDrivableSlider(this, "End Pause", "pauseAtEnd", 30, 0, 120, 1);

    finalizeDrivableSliders(this, 1);

    this.addWidget("toggle", "Loop", true, (val) => {
      this.properties.loop = val;
    });

    this.size = [200, 100];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onDrawForeground(ctx) {
    const w = this.size[0];
    const h = this.size[1];

    // Show progress bar
    const barY = h - 16;
    const barW = w - 20;
    const text = this._lastText || "";
    const progress = text.length > 0 ? this._charIndex / text.length : 0;

    ctx.fillStyle = "rgba(0,0,0,0.3)";
    ctx.fillRect(10, barY, barW, 6);
    ctx.fillStyle = "#4E9EFF";
    ctx.fillRect(10, barY, barW * Math.min(progress, 1), 6);
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) {
      this.setOutputData(0, "");
      return;
    }

    const { speed, loop, pauseAtEnd } = this.properties;

    const result = tickTypewriter(
      { charIndex: this._charIndex, pauseCounter: this._pauseCounter, lastText: this._lastText },
      { text: input, speed, loop, pauseAtEnd }
    );
    this._charIndex = result.state.charIndex;
    this._pauseCounter = result.state.pauseCounter;
    this._lastText = result.state.lastText;

    this.setOutputData(0, result.value);
    this.setDirtyCanvas(true);
  }
}

LiteGraph.registerNodeType("effects/Typewriter", TypewriterNode);
